import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Ajax from 'axios';

import {emailValidation} from '../../../utils/itemValidation';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);



class Footer extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      newsletterEmail: '',
      emailSubmitted: false,
    };
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  locateStoreChange(evt) {
    if(evt.target.value !== '') {
      this.userNav(evt.target.value);
    }
  }

  openIntercom() {
    acquireIO.max();
  }

  openContact() {
    this.props.commonOpenContact();
  }

  submitNewsletter() {
    if(emailValidation(this.state.newsletterEmail) === null) {
      // Submit email
      this.setState({ emailSubmitted : true });
      // this.props.commonNewsletterSubmit(this.state.newsletterEmail);

      const params = new FormData();
      params.append('email', this.state.newsletterEmail.trim());

      Ajax.post('https://diamondsdirect.com/newsletter/subscriber/new/', params, {
        method:'post',
        withCredentials: true,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
        // this.setState({message:response.data.message});
        // setTimeout(()=>{
          // this.setState({message:''});
        // },10000);
      })
      .catch((error)=> {
        console.error(error);
      });


    }
  }

  changeEmail(evt) {
    this.setState({ newsletterEmail: evt.target.value });
  }

  render() {
    return <div className='Footer'>
      <div className='topFooter'>
        {this.state.emailSubmitted ?
          <div className={'newsletterWrapper desktopOnly'}>
            <div className='newsletterConfirmation'>Thank you and stay tuned!</div>
          </div> :
          <div className={'newsletterWrapper desktopOnly'}>
            <input type='email' placeholder='Join the Newsletter' onChange={::this.changeEmail} />
            <div className='newsletterSubmit' onClick={::this.submitNewsletter}>Join</div>
          </div>
        }
        
        <div className='midLogoWrapper' onClick={() => this.userNav('')}>
          <LazyLoadImage className='footerLogo' src='https://ddw2.diamondsdirect.com/img/icons/footer/ddhorizontal.svg' />
          <LazyLoadImage className='footerIcon' src='https://ddw2.diamondsdirect.com/img/header/ddicon.svg' />
        </div>
        <div className={'locateWrapper desktopOnly'}>
          <select onChange={::this.locateStoreChange} name='storeSelection'>
            <option value=''>Locate A Store</option>
            <option value='austin'>Austin, TX</option>
            <option value='birmingham'>Birmingham, AL</option>
            <option value='boca-raton'>Boca Raton, FL</option>
            <option value='charleston'>Charleston, SC</option>
            <option value='charlotte'>Charlotte, NC</option>
            <option value='cleveland'>Cleveland, OH</option>
            <option value='columbus'>Columbus, OH</option>
            <option value='dallas'>Dallas, TX</option>
            <option value='frisco'>Frisco, TX</option>
            <option value='greenville'>Greenville, SC</option>
            <option value='baybrook'>Houston (Baybrook), TX</option>
            <option value='houston'>Houston (Galleria), TX</option>
            <option value='indianapolis'>Indianapolis, IN</option>
            <option value='jacksonville'>Jacksonville, FL</option>
            <option value='kansas-city'>Kansas City, KS</option>
            <option value='new-orleans'>New Orleans, LA</option>
            <option value='oklahoma-city'>Oklahoma City, OK</option>
            <option value='pittsburgh'>Pittsburgh, PA</option>
            <option value='raleigh'>Raleigh, NC</option>
            <option value='richmond'>Richmond, VA</option>
            <option value='st-louis'>St Louis, MO</option>
            <option value='san-antonio'>San Antonio, TX</option>
            <option value='troy'>Troy, MI</option>
            <option value='tysons'>Tysons, VA</option>
            <option value='virginia-beach'>Virginia Beach, VA</option>
          </select>
          <div className='selectArrow'></div>
        </div>
      </div>


      <div className={'midFooter midDesktop'}>
        <div className='linkColumn'>
          <div className='footerTitle'>Support &amp; Service</div>
          <div className='footerLink' onClick={() => this.internalNav('contact-us')}>Contact Us</div>
          <div className='footerLink' onClick={() => this.internalNav('frequently-asked-questions')}>FAQs</div>
          <div className='footerLink' onClick={() => this.internalNav('appointments')}>Request an Appointment</div>
          <div className={'footerLink longLink'} onClick={() => this.internalNav('our-guarantees')}>Warranties &amp; Guarantees</div>
          <div className={'footerLink shortLink'} onClick={() => this.internalNav('our-guarantees')}>Guarantees</div>
          <div className='footerLink' onClick={() => this.internalNav('financing')}>Payment Options</div>
          <div className='footerLink' onClick={() => this.internalNav('heroes')}>Hero Discount</div>
          <div className='footerLink' onClick={() => this.internalNav('locations')}>Store Locator</div>
          <div className='footerLink' onClick={::this.openIntercom}>Chat Now</div>

        </div>
        <div className='linkColumn'>
          <div className='footerTitle'>Shop</div>
          <div className='footerLink' onClick={() => this.internalNav('diamond-pendants')}>Pendants</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/wedding-bands/womens')}>Wedding Bands</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/fine-jewelry?type=earring')}>Earrings</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/fine-jewelry?type=necklace')}>Necklaces</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/engagement-rings?tabtype=setting')}>Engagement Rings</div>
          <div className='footerLink' onClick={() => this.internalNav('diamond-bracelets')}>Bracelets</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/fine-jewelry?type=ring')}>Fashion Rings</div>
          <div className='footerLink' onClick={() => this.userNav('custom-design')}>Custom Design</div>
        </div>
        <div className={'linkColumn desktopOnly'}>
          <div className='footerTitle'>About Us</div>
          <div className='footerLink' onClick={() => this.internalNav('about-us')}>Our Story</div>
          <div className={'footerLink longLink'} onClick={() => this.internalNav('education/conflict-free')}>Conflict Free Diamonds</div>
          <div className={'footerLink shortLink'} onClick={() => this.internalNav('education/conflict-free')}>Conflict Free</div>
          <div className='footerLink' onClick={() => this.internalNav('our-foundation')}>Community Giving</div>
          <div className='footerLink' onClick={() => this.openNew('http://blog.diamondsdirect.com/')}>Blog</div>
          <div className='footerLink' onClick={() => this.internalNav('careers')}>Careers</div>
          <div className='footerLink' onClick={() => this.internalNav('privacy-policy')}>Privacy</div>
          <div className='footerLink' onClick={() => this.internalNav('terms-of-use')}>Terms of Use</div>
          <div className='footerLink' onClick={() => this.openNew('https://www.trustpilot.com/review/www.diamondsdirect.com')}>Customer Reviews</div>
        </div>
      </div>

      <div className={'midFooter midMobile'}>
        <div className='linkColumn'>
          <div className='footerLink' onClick={() => this.userNav('gallery/engagement-rings?tabtype=setting')}>Engagement Rings</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/wedding-bands/womens')}>Wedding Bands</div>
          <div className='footerLink' onClick={() => this.userNav('gallery/fine-jewelry?type=necklace')}>Necklaces</div>
          <div className='footerLink' onClick={() => this.internalNav('diamond-bracelets')}>Bracelets</div>
          
        </div>
        <div className='linkColumn'>
          <div className='footerLink' onClick={() => this.internalNav('frequently-asked-questions')}>FAQs</div>
          <div className='footerLink' onClick={() => this.internalNav('financing')}>Payment Options</div>
          <div className='footerLink' onClick={() => this.internalNav('locations')}>Store Locator</div>
          <div className='footerLink' onClick={() => this.internalNav('careers')}>Careers</div>
        </div>
        
      </div>


      <div className='bottomFooter'>
        <div className='bottomMidWrapper'>
          <div className='phonePrompt'><a href='tel:8008855050'>800.885.5050</a></div>
          <div className='footerSocial'>
            <div className={'footerIconWrapper facebookIcon'} onClick={() => this.openNew('https://www.facebook.com/diamondsdirectstore/')}>
            </div>
            <div className={'footerIconWrapper glassdoorIcon'} onClick={() => this.openNew('https://www.glassdoor.com/Overview/Working-at-Diamonds-Direct-EI_IE1284378.11,26.htm')}>
            </div>
            <div className={'footerIconWrapper instagramIcon'} onClick={() => this.openNew('https://www.instagram.com/diamondsdirect/')}>
            </div>
            <div className={'footerIconWrapper linkedinIcon'} onClick={() => this.openNew('https://www.linkedin.com/company/diamonds-direct/jobs')}>
            </div>
            <div className={'footerIconWrapper pinterestIcon'} onClick={() => this.openNew('https://www.pinterest.com/diamondsdirect/')}>
            </div>
          </div>
          <div className='emailPrompt' onClick={::this.openContact} style={{ display: 'none' }}>Contact Us</div>
          <div className='blogPrompt' onClick={() => this.openNew('http://blog.diamondsdirect.com/')} style={{ display: 'none' }}>Blog</div>
        </div>
        <div className='footerLHS' style={{ display: 'none' }}>
          <div className='bottomLink' onClick={() => this.internalNav('privacy-policy')}>Privacy</div>
          <div className='bottomLink' onClick={() => this.internalNav('terms-of-use')}>Terms of Use</div>
        </div>
        <div className='footerRHS'>
          <div className='badgeWrapper'>
            <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/footer/weddingwire.svg' />
          </div>
          <div className='badgeWrapper'>
            <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/icons/footer/knot.svg' />
          </div>
        </div>
      </div>
    </div>
  }
}
export default Footer;

function mapStateToProps(state) {
  return {

  };
}

export const FooterContainer = connect(
  mapStateToProps,
  allActionCreators
)(Footer);


// WEBPACK FOOTER //
// ./src/components/views/footer/Footer.jsx